import React from "react";
import { render } from "react-dom";
import { Provider } from "react-redux";
import { Router, Route, IndexRedirect, IndexRoute, browserHistory } from "react-router";
import axios from "axios";
import moment from "moment";
import qs from "qs";
import "core-js";
import { setLocale } from "yup";
import { cleanLocalStorage } from "./utils/cleanPersistStore";
import { locale as yupLocale } from "./locale/yup";

// Set moment to Dutch
moment.locale("nl");
// Set Yup (schema validation) locale:
setLocale(yupLocale.nl);

// Import reducers
// import rootReducer from './reducers/index';

// Import components
import App from "./components/App";

// Import pages
import Login from "./pages/login/Login";
import Outdated from "./pages/Outdated";
import LoginPasswordReset from "./pages/login/LoginPasswordReset";
import LoginPasswordLost from "./pages/login/LoginPasswordLost";

import Home from "./pages/Home";
import Intro from "./pages/Intro";
import Privacy from "./pages/Privacy";
import TermsOfUse from "./pages/TermsOfUse";
import Account from "./pages/Account";
import { News } from "./pages/News";

import CoursesOverview from "./pages/courses/overview";
// import CoursesForm from "./pages/courses/form";
import CoursesEdit from "./pages/courses/CoursesEdit";
// import CoursesDetails from './pages/courses/details';
import CoursesGeneral from "./pages/courses/general";
// import CoursesStudents from './pages/courses/students';
import CoursesDownloads from "./pages/courses/downloads";
import CoursesInvoices from "./pages/courses/invoices";
import CourseDetail from "./pages/courses/CourseDetail";

import LocationsOverview from "./pages/locations/overview";
import LocationsForm from "./pages/locations/form";

import competenceprofilesOverview from "./pages/competenceprofiles/overview";
import competenceprofilesForm from "./pages/competenceprofiles/form";
import competenceprofilesCompetences from "./pages/competenceprofiles/competences";
import competenceprofilesMeasurements from "./pages/competenceprofiles/measurements";
import competenceprofilesBundles from "./pages/competenceprofiles/bundles";
import competenceprofilesResume from "./pages/competenceprofiles/resume";
import measurementMoments from "./pages/competenceprofiles/measurementmoments/overview";
import measurementMomentsForm from "./pages/competenceprofiles/measurementmoments/form";
import knowledgeexamsOverview from "./pages/competenceprofiles/measurementmoments/knowledgeexams";

import masterdataEndterms from "./pages/masterdata/Endterms";
import masterdataEndtermsForm from "./pages/masterdata/EndtermsForm";
import masterdataCompetences from "./pages/masterdata/Competences";
import masterdataCompetencesForm from "./pages/masterdata/CompetencesForm";
import masterdataMeasurementBundles from "./pages/masterdata/MeasurementBundles";
import masterdataMeasurementBundlesForm from "./pages/masterdata/MeasurementBundlesForm";
import masterdataMeasurements from "./pages/masterdata/Measurements";
import masterdataMeasurementsForm from "./pages/masterdata/MeasurementsForm";

import StudentsOverview from "./pages/students/overview";
import StudentsForm from "./pages/students/form";
import StudentsView from "./pages/students/view";
import StudentsCompetenceprofiles from "./pages/students/competenceprofiles";
import StudentsCertificates from "./pages/students/certificates";
import StudentsFiles from "./pages/students/files";
import StudentsCourses from "./pages/students/courses";

import UsersOverview from "./pages/users/overview";
import UsersForm from "./pages/users/form";

import TrainersOverview from "./pages/trainers/overview";
import TrainersForm from "./pages/trainers/form";

import ReportsOverview from "./pages/reports/overview";
import ReportsDownload from "./pages/reports/download";

import AuthoritiesOverview from "./pages/authorities/overview";
import AuthoritiesForm from "./pages/authorities/form";

import InstructorsOverview from "./pages/instructors/overview";
import InstructorsForm from "./pages/instructors/form";

import InvoicesOverview from "./pages/invoices/overview";
import InvoicesView from "./pages/invoices/view";

// Import styling
import "./scss/main.scss";

// Import history and store
// import store, { history } from './store';

import configureStore from "./store";
import { logout, setUserData } from "./actions/authentication";
import { userMayLogin } from "./utils/auth";
import AuditOverview from "./pages/audits/overview";
import AuditDetail from "./pages/audits/detail";
import PassesCoursesOverview from "./pages/passes/overview";
import PassCourseDetail from "./pages/passes/detail";

// Set the defaults options for axios
axios.defaults.baseURL = APP_CONFIG.api_url;
axios.defaults.timeout = 30000;
axios.defaults.headers.Accept = "application/json";
// by set NL to be the preferred language:
axios.defaults.headers["Accept-Language"] = "nl-NL, nl;q=0.9, en-GB, en-US, en;q=0.8";
axios.defaults.paramsSerializer = (params) => {
    return qs.stringify(params, { arrayFormat: "repeat" });
};
axios.interceptors.request.use((config) => {
    const { url, baseURL } = config;
    if (baseURL !== "/") {
        const [path, params] = url.split("?", 2);
        if (!path.endsWith("/")) {
            console.warn(`Requested URL did not end with a slash which can lead to obscure errors! ${url}`);
            // auto-append the slash and update the config:
            if (params) {
                config.url = `${path}/?${params}`;
            } else {
                config.url = `${path}/`;
            }
            console.trace(`Auto-corrected the URL to: ${config.url}`);
        }
    }
    return config;
});

// Check if we have a token in the local storage
// if (localStorage.loginToken !== undefined && !['invalid','blocked','loggedout'].includes(localStorage.loginToken)) {
//     axios.defaults.headers.Authorization = 'Token ' + localStorage.loginToken;
// }
//
// if (localStorage.userPermissions && localStorage.userPermissions == 'undefined') {
//     localStorage.clear();
//     window.location = '/';
// }

// This function checks the authentication before we enter a page
// This is the place to check restrictions or privileges per user
// function checkAuthentication() {
//     // console.info("checkAuthentication", arguments, {STATE: store.getState()});
//   // Check if the loginToken is set, otherwise redirect to login
//   if (localStorage.loginToken !== undefined && !['invalid','blocked','loggedout'].includes(localStorage.loginToken)) {
//     axios.defaults.headers.Authorization = 'Token ' + localStorage.loginToken;
//
//     // Check if the user that is currently logged in still has access
//     // While we do this, also get the latest data of the user
//
//     axios.get('/v1/users/self/')
//     .then((response) => {
//       localStorage.userUUID = response.data.uuid;
//       localStorage.userEmail = response.data.email;
//       localStorage.userName = response.data.full_name;
//       localStorage.userPermissions = JSON.stringify(response.data.permissions);
//       localStorage.userRoles = JSON.stringify(response.data.roles);
//       localStorage.companyAuthorizations = JSON.stringify(response.data.company_authorizations);
//
//       if (response.data.is_blocked) {
//         localStorage.clear();
//         localStorage.loginToken = 'blocked';
//         window.location = '/login';
//       }
//       else if (response.data.onboarding_state !== APP_CONFIG.onboarding_state) {
//         // Privacy statement is not accepted, forward the user to the privacy statement
//         window.location = '/intro';
//       }
//       else if (response.data.roles.length === 1 && response.data.roles.includes('student')) {
//         localStorage.clear();
//         localStorage.loginToken = 'invalid';
//         window.location = '/login';
//       }
//       else if (response.data.roles.length === 2 && response.data.roles.includes('student') && response.data.roles.includes('instructor')) {
//         localStorage.clear();
//         localStorage.loginToken = 'invalid';
//         window.location = '/login';
//       }
//     })
//     .catch((error) => {
//       // Error while verifying this user, log out and redirect to login screen
//       // Remember the current locations
//       localStorage.clear();
//       localStorage.loginToken = 'blocked';
//       window.location = '/login';
//     });
//   }
//   else {
//     localStorage.clear();
//     // localStorage.currentLocation = window.location;
//     window.location = '/login';
//   }
// }

// Some pages need the user to be logged out
function forceLogout() {
    localStorage.clear();
}

// Set default options for the react-select component
window.selectDefaults = {
    noResultsText: "Geen resultaten gevonden",
    placeholder: "Selecteer een optie",
    searchPromptText: "Typ om te zoeken",
    loadingPlaceholder: "Laden...",
    clearAllText: "Alle geselecteerde items verwijderen",
    clearValueText: "Dit veld leegmaken",
    closeOnSelect: false,
    inputProps: { autoComplete: "off" },
    backspaceRemoves: false,
    onSelectResetsInput: false,
    tabSelectsValue: false,
    ignoreAccents: true,
    ignoreCase: true
};

// Check the latest version
axios.get(`/meta.json?${Math.round(Math.random() * 10000)}`, { baseURL: "/" }).then((response) => {
    // Both checks below could be combined. However I deliberately separated them to explicitly underscore the fact
    // that they are two separated situations which should not be confused

    // Check if the current compiled Javascript version matches what the server knows to be the latest version
    if (response?.data?.version && response.data.version !== COMMIT_HASH) {
        cleanLocalStorage(COMMIT_HASH);
        window.location.reload(true);
        return;
    }

    // Check if the current localStorage version matches what the compiled Javascript version knows to be the latest version
    // We do NOT use the meta.json because having a mismatch between state and js is more wrong than state and serversided
    if (localStorage?.getItem("commitHash") !== COMMIT_HASH) {
        cleanLocalStorage(COMMIT_HASH);
        // #1881 - Disabled this reload as it's causing an infinite reload loop on
        // the password reset page. No clue why but for some reason
        // localStorage simply isn't... storing...
        // window.location.reload(true);
    }
});

async function init() {
    const { store, history } = await configureStore();

    /**
     * Checks the users authentication status by fetching the user data from the API.
     * If the user is not logged in or is blocked, the user is redirected to the login
     * page.
     * @returns {Promise<void>}
     */
    async function checkUserAuth() {
        const state = store.getState();
        const { loginToken } = state.authentication;
        if (!loginToken) {
            window.location = "/login";
            return;
        }
        await axios
            .get("/v1/users/self/")
            .then((response) => {
                const [mayLogin, errorCode] = userMayLogin(response.data);
                if (mayLogin) {
                    // update the user data in the store:
                    store.dispatch(setUserData(response.data));

                    if (response.data.onboarding_state !== APP_CONFIG.onboarding_state) {
                        window.location = "/intro";
                    }
                } else {
                    // user is not allowed to use the app (blocked or no valid roles):
                    store.dispatch(logout(errorCode));
                    window.location = "/login";
                }
            })
            .catch((error) => {
                store.dispatch(logout("server_error"));
                window.location = "/login";
            });
    }

    const router = (
        <Provider store={store}>
            <Router history={history}>
                <Route path="/" component={App}>
                    <IndexRoute component={Login} />
                    <Route path="login" component={Login} />
                    <Route path="password-reset/:uidb/:passwordtoken" component={LoginPasswordReset} onEnter={forceLogout} />
                    <Route path="password-lost" component={LoginPasswordLost} onEnter={forceLogout} />
                    <Route path="outdated" component={Outdated} />

                    <Route path="home" component={Home} onEnter={checkUserAuth} />

                    <Route path="intro" component={Intro} />
                    <Route path="privacy" component={Privacy} />
                    <Route path="terms-of-use" component={TermsOfUse} />
                    <Route path="news" component={News} onEnter={checkUserAuth} />

                    <Route path="courses" onEnter={checkUserAuth}>
                        <IndexRoute component={CoursesOverview} />

                        {/* New Course */}
                        {/*<Route path="new_old" component={CoursesForm} />*/}

                        {/* Omni New Course */}
                        <Route path="new" component={CoursesEdit} />

                        {/* Edit course (like new)*/}
                        <Route path="edit/:itemID">
                            <IndexRoute component={CoursesEdit} />
                            {/*<Route path="details" component={CoursesDetails} />*/}

                            {/* Edit course (in popover )*/}
                            <Route path="general" component={CoursesGeneral} />

                            {/*<Route path="students" component={CoursesStudents} />*/}
                            <Route path="invoices" component={CoursesInvoices} />
                            <Route path="downloads" component={CoursesDownloads} />
                            <Route path="students" component={CourseDetail} />
                            <Route path="details" component={CourseDetail} />
                        </Route>
                    </Route>

                    <Route path="instructors" onEnter={checkUserAuth}>
                        <IndexRoute component={InstructorsOverview} />
                        <Route path="new" component={InstructorsForm} />
                        <Route path="edit/:itemID" component={InstructorsForm} />
                    </Route>

                    <Route path="trainers" onEnter={checkUserAuth}>
                        <IndexRoute component={TrainersOverview} />
                        <Route path="new" component={TrainersForm} />
                        <Route path="edit/:itemID" component={TrainersForm} />
                    </Route>

                    <Route path="invoices" onEnter={checkUserAuth}>
                        <IndexRoute component={InvoicesOverview} />
                        <Route path="view/:itemID" component={InvoicesView} />
                    </Route>

                    <Route path="students" onEnter={checkUserAuth}>
                        <IndexRoute component={StudentsOverview} />
                        <Route path="new" component={StudentsForm} />
                        <Route path="edit/:itemID" component={StudentsForm} />
                        <Route path="view/:itemID" component={StudentsView} />
                        <Route path="competenceprofiles/:itemID" component={StudentsCompetenceprofiles} />
                        {/*<Route path="competenceprofiles/:itemID/:cpID" component={StudentsCompetenceprofiles} />*/}
                        <Route path="certificates/:itemID" component={StudentsCertificates} />
                        <Route path="files/:itemID" component={StudentsFiles} />
                        <Route path="courses/:itemID" component={StudentsCourses} />
                        <Route path="courses/:itemID/:courseUUID" component={StudentsCourses} />
                    </Route>

                    <Route path="users" onEnter={checkUserAuth}>
                        <IndexRoute component={UsersOverview} />
                        <Route path="new" component={UsersForm} />
                        <Route path="edit/:itemID" component={UsersForm} />
                    </Route>

                    <Route path="authorities" onEnter={checkUserAuth}>
                        <IndexRoute component={AuthoritiesOverview} />
                        <Route path="new" component={AuthoritiesForm} />
                        <Route path="edit/:itemID" component={AuthoritiesForm} />
                    </Route>

                    <Route path="locations" onEnter={checkUserAuth}>
                        <IndexRoute component={LocationsOverview} />
                        <Route path="new" component={LocationsForm} />
                        <Route path="edit/:itemID" component={LocationsForm} />
                    </Route>

                    <Route path="competenceprofiles" onEnter={checkUserAuth}>
                        <IndexRoute component={competenceprofilesOverview} />
                        <Route path="new" component={competenceprofilesForm} />
                        <Route path="edit/:itemID">
                            <IndexRoute component={competenceprofilesForm} />
                            <Route path="competences" component={competenceprofilesCompetences} />
                            <Route path="measurements" component={competenceprofilesMeasurements} />
                            <Route path="bundles" component={competenceprofilesBundles} />
                            <Route path="resume" component={competenceprofilesResume} />
                            <Route path="measurementmoments">
                                <IndexRoute component={measurementMoments} />
                                <Route path="new" component={measurementMomentsForm} />
                                <Route path="edit/:eventTypeID" component={measurementMomentsForm} />
                                <Route path="knowledgeexams/:eventTypeID" component={knowledgeexamsOverview} />
                            </Route>
                        </Route>
                    </Route>

                    <Route path="masterdata" onEnter={checkUserAuth}>
                        <IndexRedirect to="/masterdata/endterms" />

                        <Route path="endterms">
                            <IndexRoute component={masterdataEndterms} />
                            <Route path="new" component={masterdataEndtermsForm} />
                            <Route path="edit/:itemID" component={masterdataEndtermsForm} />
                        </Route>

                        <Route path="competences">
                            <IndexRoute component={masterdataCompetences} />
                            <Route path="new" component={masterdataCompetencesForm} />
                            <Route path="edit/:itemID" component={masterdataCompetencesForm} />
                        </Route>

                        <Route path="measurementbundles">
                            <IndexRoute component={masterdataMeasurementBundles} />
                            <Route path="new" component={masterdataMeasurementBundlesForm} />
                            <Route path="edit/:itemID" component={masterdataMeasurementBundlesForm} />
                        </Route>

                        <Route path="measurements">
                            <IndexRoute component={masterdataMeasurements} />
                            <Route path="new" component={masterdataMeasurementsForm} />
                            <Route path="edit/:itemID" component={masterdataMeasurementsForm} />
                        </Route>
                    </Route>

                    <Route path="/reports" onEnter={checkUserAuth}>
                        <IndexRoute component={ReportsOverview} />
                        <Route path=":uuid" component={ReportsDownload} />
                    </Route>

                    <Route path="audits" onEnter={checkUserAuth}>
                        <IndexRoute component={AuditOverview} />
                        <Route path=":uuid" component={AuditDetail} />
                    </Route>

                    <Route path="passes" onEnter={checkUserAuth}>
                        <IndexRoute component={PassesCoursesOverview} />
                        <Route path=":uuid" component={PassCourseDetail} />
                    </Route>

                    <Route path="/courses" component={CoursesOverview} onEnter={checkUserAuth} />

                    <Route path="/account" component={Account} onEnter={checkUserAuth} />
                </Route>
            </Router>
        </Provider>
    );
    render(router, document.getElementById("root"));
}

init();
